/* global ol */

/**
 * If a route or car feature is double clicked, select and zoom to fit that route,
 * otherwise zoom the map in one level (or out if the shift key is pressed).
 */

function DoubleClickZoomInteraction(map) {
  this.map = map;

  this.doubleClickZoom = new ol.interaction.DoubleClickZoom({
    duration: 0
  });

  this.interaction = new ol.interaction.Interaction({
    handleEvent: this.handleEvent.bind(this)
  });
}

DoubleClickZoomInteraction.prototype.handleEvent = function(event) {
  return ol.events.condition.doubleClick(event)
    ? this.onDoubleClick(event)
    : true;
};

DoubleClickZoomInteraction.prototype.onDoubleClick = function(event) {
  var route = this.routeAtPixel(event);

  if (route) {
    this.map.scope.map.selectRoute(route);
    this.map.routeZoomControl.zoomToFitRoute();
    this.map.scope.$apply();
    event.preventDefault();
  } else {
    this.doubleClickZoom.handleEvent(event);
  }

  return false;
};

DoubleClickZoomInteraction.prototype.routeAtPixel = function(event) {
  return event.map.forEachFeatureAtPixel(event.pixel, function(feature, layer) {
    if(layer) return layer.get('route');
  });
};

module.exports = DoubleClickZoomInteraction;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/doubleClickZoomInteraction.js
 ** module id = 175
 ** module chunks = 1
 **/